import { QueryCache, QueryClient } from '@tanstack/react-query';

export const apiQueryCache = new QueryCache();
export const apiQueryClient = new QueryClient({ queryCache: apiQueryCache });
